import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  Constraint,
  Event,
  Id,
  Identifiable,
  List,
  Milestone,
  Task,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  constraints: (Identifiable<Constraint> & {
    targetStartDate: string;
    targetEndDate: string;
    targetIsDone: boolean;
    originStartDate: string;
    originEndDate: string;
    originIsDone: boolean;
  })[];
  retrieveConstraints(
    request: Boundaries["retrieveConstraints"]["request"],
  ): void;
}

function useRetrieveConstraints(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isRetrieveConstraintsRequestPending),
    isRequestSuccess: useSelector(selector.isRetrieveConstraintsRequestSuccess),
    isRequestFailure: useSelector(selector.isRetrieveConstraintsRequestFailure),
    constraints: useSelector(selector.getConstraints),
    retrieveConstraints: core.retrieveConstraints,
  };
}

export { useRetrieveConstraints };
